<template>
    <div>
        <div>
            <el-row :gutter="20">
                <el-col :xm="24" :md="12" :lg="14" style="margin-bottom:30px;">
                    <div class="biaoqian">混剪视频制作v2</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <div style="font-size: 14px;">
                            <qhyupload ref="qhyupload"></qhyupload>
                            <div style="margin-top:25px;">
                                <div style="margin:10px 0px;font-weight: 600;color: #666;">混剪模式</div>
                                <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                                    <div v-for="(item, index) in ms_data.ms_list" :key="index"
                                        style="background-color: #eaeaea;border-radius: 5px;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;"
                                        @click="ms_xz = item"
                                        :style="{ backgroundColor: (ms_xz.name == item.name ? '#484add' : '#eaeaea'), color: (ms_xz.name == item.name ? '#fff' : '#5a5a5a') }">
                                        <div class="no-select">{{ item.name }}</div>
                                    </div>
                                </div>
                                <div style="margin-top: 5px;font-size: 12px;color: #999;">
                                    功能介绍: {{ ms_xz.title }}
                                </div>
                            </div>
                            <div style="margin-top:25px;">
                                <div style="margin:10px 0px;font-weight: 600;color: #666;">附加选项
                                    <a style="font-size: 1.3vh;color: #999;">(建议最多5个)</a>
                                </div>
                                <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                                    <div v-for="(item, index) in ms_data.other" :key="index"
                                        style="background-color: #eaeaea;border-radius: 5px;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;"
                                        @click="item.zt = !item.zt"
                                        :style="{ backgroundColor: (item.zt ? '#484add' : '#eaeaea'), color: (item.zt ? '#fff' : '#5a5a5a') }">
                                        <div class="no-select">{{ item.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top:25px;">
                                <div style="margin:10px 0px;font-weight: 600;color: #666;">高级设置</div>
                                <div style="font-size: 12px;color: #999;margin-bottom: 15px;">0代表不设置，功能不生效</div>
                                <div style="display:flex;justify-content: space-between;align-items: center;">
                                    <div>固定音乐</div>
                                    <div style="color:#888;">
                                        第<el-input-number v-model="hj_data.fixed_music" :min="0" label="描述文字"
                                            size="mini" style="width: 100px;margin: 0px 5px;"></el-input-number>个视频
                                    </div>
                                </div>
                                <div
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>固定开头</div>
                                    <div style="color:#888;">
                                        第<el-input-number v-model="hj_data.fixed_start" :min="0" label="描述文字"
                                            size="mini" style="width: 100px;margin: 0px 5px;"></el-input-number>个视频
                                    </div>
                                </div>
                                <div
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>总时长模式</div>
                                    <el-radio-group v-model="duration_mode" size="mini">
                                        <el-radio-button label="fixed">固定总时长</el-radio-button>
                                        <el-radio-button label="limit">限制总时长</el-radio-button>
                                    </el-radio-group>
                                </div>
                                <div v-if="duration_mode === 'fixed'"
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>固定总时长(秒)</div>
                                    <div style="color:#888;">
                                        <el-input-number v-model="hj_data.fixed_duration" :min="0" :step="0.5"
                                            label="描述文字" size="mini"
                                            style="width: 100px;margin: 0px 5px;"></el-input-number>
                                    </div>
                                </div>
                                <div v-if="duration_mode === 'limit'"
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>限制单条视频(秒)</div>
                                    <div style="color:#888;">
                                        <el-input-number v-model="hj_data.limit_per_video" :min="0" :step="0.5"
                                            label="描述文字" size="mini"
                                            style="width: 100px;margin: 0px 5px;"></el-input-number>
                                    </div>
                                </div>
                                <div v-if="duration_mode === 'limit'"
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>限制总时长(秒)</div>
                                    <div style="color:#888;">
                                        <el-input-number v-model="hj_data.limit_total_duration" :min="0" :step="0.5"
                                            label="描述文字" size="mini"
                                            style="width: 100px;margin: 0px 5px;"></el-input-number>
                                    </div>
                                </div>
                                <div
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>生成视频数量</div>
                                    <div style="color:#888;">
                                        <el-input-number v-model="hj_data.make_num" :min="1" :max="10" label="描述文字"
                                            size="mini"></el-input-number>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top:30px;">
                                <el-button @click="ks()"
                                    style="width:100%;background-color: #484add;border-color: #484add;"
                                    type="success">立即制作</el-button>
                            </div>
                        </div>

                    </el-card>
                </el-col>
                <el-col :xm="24" :md="12" :lg="10">
                    <div class="biaoqian">制作记录</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <div style="font-size: 14px;">
                            <!-- <div style="margin:10px 0px;">制作记录</div> -->
                            <Record></Record>
                        </div>

                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Record from "../User/Record.vue"
export default {
    name: 'Hj2',
    components: {
        Record,
    },
    // 定义属性
    data() {
        return {
            ms_data: [],
            ms_xz: '其他混剪',
            hj_data: {
                fixed_music: 0,
                fixed_start: 0,
                make_num: 1,
                fixed_duration: 0,
                limit_total_duration: 0,
                limit_per_video: 0,
            },
            duration_mode: 'limit',
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ks() {
            var urls = this.$refs.qhyupload.get_urls()
            if (urls.status == 100) {
                return this.$msg.error(urls.msg)
            }
            var videoCount = this.$refs.qhyupload.url_list.length
            if (this.hj_data.fixed_music > videoCount || this.hj_data.fixed_start > videoCount) {
                return this.$msg.error('固定音乐或固定开头的序号不能超过视频数量')
            }
            var ms = this.ms_xz.name + '-'
            for (var i = 0; i < this.ms_data.other.length; i++) {
                if (this.ms_data.other[i].zt) {
                    ms += this.ms_data.other[i].value
                }
            }
            if (this.duration_mode === 'fixed') {
                this.hj_data.limit_total_duration = 0
                this.hj_data.limit_per_video = 0
            } else {
                this.hj_data.fixed_duration = 0
            }
            var data = {
                'url': urls,
                'ms': ms,
                'other': JSON.stringify(this.hj_data),
                'type': 'hjv2'
            }
            console.log(data)
            // return
            const loading = this.$loading(this.$loadinginfo);

            this.$ajax.post('/qhy/user/makevieo', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    // console.log(index)
                    // this.$msg.success(res.data.msg)
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        customClass: 'newdialog',
                        callback: action => {
                            const balanceComp = this.$parent.$parent.$parent.$parent
                            if (balanceComp && typeof balanceComp.get_balance === 'function') balanceComp.get_balance()
                            this.allurl = ''
                            this.$refs.qhyupload.clear_url()
                        }
                    });
                    // this.$refs.Balance.get_user()
                } else {
                    this.$msg.error(res.data.msg)
                }
            }).finally(() => {
                this.uploading = false
                loading.close();
            })
        },
        get_ms() {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('/qhy/user/ms_hj_v2', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.ms_data = res.data.data
                    this.ms_xz = this.ms_data.ms_list[0]
                    for (let index = 0; index < this.ms_data.other.length; index++) {
                        this.$set(this.ms_data.other[index], 'zt', false)
                    }
                }

                loading.close();
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.common.ismobile(this)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.get_ms()
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.upload2 .el-upload {
    width: 100%;
}

.upload2 .el-upload-dragger {
    width: 100%;
}

.el-radio-group .el-radio-button.is-active .el-radio-button__inner {
    background-color: #484add;
    border-color: #484add;
    box-shadow: -1px 0 0 0 #484add;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Hj2.vue



// WEBPACK FOOTER //
// src/components/User/Hj2.vue